module.exports = __webpack_public_path__ + "img/full1-min.dc1901b4.png";